import { Component } from '@angular/core';
import { Layout } from 'app/views/presentations/layouts/layout';
import { LayoutComponent } from 'app/views/presentations/layouts/layout.component';

@Component({
    selector: `psm-three-sections-layout-3-component`,
    templateUrl: 'threeSectionsLayout3.component.html',
    styleUrls: ['../layout.component.scss']
})

export class ThreeSectionsLayout3Component extends LayoutComponent { }

export class ThreeSectionsLayout3 extends Layout {
    public type = 'ThreeSectionsLayout3';
    public componentType = ThreeSectionsLayout3Component;
    public numberOfSections = 3;
}


// WEBPACK FOOTER //
// ./src/app/views/presentations/layouts/layouts/threeSectionsLayout3/threeSectionsLayout3.component.ts